import { useEffect } from "react";

const setMeta = (attr, key, content) => {
  let el = document.head.querySelector(`meta[${attr}="${key}"]`);
  if (!el) {
    el = document.createElement("meta");
    el.setAttribute(attr, key);
    document.head.appendChild(el);
  }
  el.setAttribute("content", content);
};

const SITE_URL = (process.env.REACT_APP_SITE_URL || "").replace(/\/$/, "");
const IS_PREVIEW = typeof window !== "undefined" && /emergentagent\.com$/.test(window.location.hostname);

export const useSeo = ({ title, description, path = "/", noindex = false }) => {
  useEffect(() => {
    document.title = title;
    setMeta("name", "description", description);
    setMeta("name", "robots", noindex || IS_PREVIEW ? "noindex, nofollow" : "index, follow, max-image-preview:large");
    setMeta("property", "og:title", title);
    setMeta("property", "og:description", description);
    if (!SITE_URL) return;
    setMeta("property", "og:url", SITE_URL + path);
    let link = document.head.querySelector('link[rel="canonical"]');
    if (!link) {
      link = document.createElement("link");
      link.setAttribute("rel", "canonical");
      document.head.appendChild(link);
    }
    link.setAttribute("href", SITE_URL + path);
  }, [title, description, path, noindex]);
};
